import styled, { css } from "styled-components";

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: 3.625rem;

    @media (max-width: ${theme.breakpoints.medium}) {
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
    }
  `}
`;
export const TitleContainer = styled.div`
  > h1 {
    text-align: center;
    color: #156960;
    font-size: 1.3125rem;
  }

  > h2 {
    text-align: center;
    color: #2a2e2d;
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 4.5rem;
  }
`;
